import Image from 'next/image';
import React from 'react';

import {
    Align,
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Sticker,
    Text,
    TextLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

interface PromoBorderedBlockProps {
    badge?: string;
    imageSrc?: string;
    onLinkClick?: () => void;
}

export function PromoBorderedBlock({ badge, imageSrc, onLinkClick }: Readonly<PromoBorderedBlockProps>) {
    return (
        <Box className='promo-bordered-block' shadowless>
            <BoxContent>
                <FlexBox direction={DirectionEnum.ROW} align={Align.CENTER} gap={GapSize.SIX}>
                    {imageSrc ? (
                        <Image src={imageSrc} alt='' width={86} height={86} />
                    ) : (
                        <Icon name={IconName.CERTIFIED} size={IconSize.SMALL} />
                    )}
                    <FlexBox direction={DirectionEnum.COLUMN}>
                        {badge && <Sticker className='is-marginless' small label={badge} />}
                        <div>
                            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.ONE} marginless>
                                {onLinkClick
                                    ? 'Vous trouvez moins cher ailleurs\u00A0?'
                                    : 'Vous avez trouvé moins cher ailleurs\u00A0?'}
                            </Text>
                            <Text level={TextLevels.ONE}>
                                {onLinkClick
                                    ? 'On vous rembourse la différence\u00A0!'
                                    : 'Bonne nouvelle\u00A0: on vous rembourse la différence\u00A0!'}
                            </Text>
                        </div>
                        {onLinkClick && (
                            <button type='button' className='link button-clear has-text-left' onClick={onLinkClick}>
                                Comment ça marche&nbsp;?
                            </button>
                        )}
                    </FlexBox>
                </FlexBox>
            </BoxContent>
        </Box>
    );
}
